<form [formGroup]="form" (ngSubmit)="onSubmit()" class="w-full">
  <div class="flex h-full gap-10 w-full flex-col xl:flex-row">
    <div class="w-full flex flex-col">
      <div class="w-full bg-white rounded-xl h-full p-4">
        <div class="flex space-x-2 items-center mb-4">
          <div class="h-8 w-[4px] bg-primary"></div>
          <span>Services</span>
        </div>

        <!-- Dropdown -->
        <div class="flex flex-col gap-2 mb-4">
          <span class="text-sm">Road Type *</span>
          <mat-form-field appearance="outline" class="w-full">
            <mat-select
              placeholder="Select Road Type"
              formControlName="userType"
            >
              <mat-option *ngFor="let road of roads" [value]="road">{{
                road
              }}</mat-option>
            </mat-select>
          </mat-form-field>
          <div
            *ngIf="
              form.get('userType')?.invalid && form.get('userType')?.touched
            "
            class="text-red-500 text-sm"
          >
            Road Type is required.
          </div>
        </div>

        <!-- Checkboxes -->
        <!-- <div class="flex flex-col gap-2">
          <span class="text-sm">Road *</span>
          <div class="grid grid-cols-3 gap-2" formArrayName="roadsT">
            <mat-checkbox *ngFor="let ro of roadsT; let i = index" [formControlName]="i">
              {{ ro }}
            </mat-checkbox>
          </div>
          <div *ngIf="checkboxError" class="text-red-500 text-sm">Select at least one road.</div>
        </div> -->
        <!-- Checkboxes -->
        <div class="flex flex-col gap-2">
          <span class="text-sm">Road *</span>
          <div class="grid grid-cols-3 gap-2" formArrayName="roadsT">
            <mat-checkbox
              *ngFor="let ro of roadsT; let i = index"
              [formControlName]="i"
             
            >
              <span >{{ ro }}</span>
            </mat-checkbox>
          </div>
          <div *ngIf="checkboxError" class="text-red-500 text-sm">
            Select at least one road.
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="w-full flex items-center justify-end mt-4">
    <button mat-raised-button color="primary" type="submit" class="w-60">
      Save
    </button>
  </div>
</form>
